import { createContext, useContext, useState } from 'react';

const InspectorContext = createContext(null);

export function InspectorProvider({ children }) {
    const [isDirty, setIsDirty] = useState(false);
    const [activeGid, setActiveGid] = useState(null); // ADDED

    return (
        <InspectorContext.Provider value={{ isDirty, setIsDirty, activeGid, setActiveGid }}>
            {children}
        </InspectorContext.Provider>
    );
}

export function useInspector() {
    return useContext(InspectorContext);
}
